import ReactGA from "react-ga4"

import {PRODUCTION} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"
import localStorage from "@irati/region/helpers/storage"

const PROD_TRACKING_ID = "G-6B74P2DYKB"
const STAGE_TRACKING_ID = "G-L5VEKDKGYD"

const init = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    ReactGA.initialize(PROD_TRACKING_ID)
  } else {
    ReactGA.initialize(STAGE_TRACKING_ID)
  }
}

const trackEvent = (name: string, params: object) => {
  ReactGA.event(name, params)
}

const trackEventWithStore = (name: string, storeItem: string, params?: object) => {
  const storedData = JSON.parse(localStorage.getItem(storeItem) || "{}") as object
  if (params) {
    const updated = {}
    if (storedData) {
      Object.entries(params).forEach(([key, value]) => {
        if (Object.keys(storedData).find((k) => k === key)) {
          Object.assign(updated, {[key]: value})
        }
      })
    }
    localStorage.setItem(storeItem, JSON.stringify({...storedData, ...updated}))
  }

  ReactGA.event(name, {...storedData, ...params})
}

export default {
  init,
  trackEvent,
  trackEventWithStore
}
